import { ReactComponent as DotsSVG } from "../../assets/dots-three-vertical.svg";
import useFormatter from "../../hooks/useFormatter";
import DeviceInterface, {
  DevicePhasesActiveStatus,
} from "../../interfaces/DeviceInterface";

import BoosterIcon from "./BoosterIcon";
import DeviceStatus from "./DeviceStatus";

import { Link, generatePath } from "react-router-dom";

import "./device.scss";

function DevicePhase({
  phasesActiveStatus,
}: {
  phasesActiveStatus?: DevicePhasesActiveStatus;
}) {
  return (
    <div className="phases">
      {["L3", "L2", "L1"].map((v) => {
        const phase = v as "L1" | "L2" | "L3";

        return (
          <div
            key={phase}
            className={[
              "phase",
              phasesActiveStatus?.[phase] ? "active" : undefined,
            ]
              .filter((e) => e)
              .join(" ")}
          />
        );
      })}
    </div>
  );
}

function DevicePreview({ device }: { device: DeviceInterface }) {
  const { formatElectricity } = useFormatter();

  return (
    <Link
      to={generatePath("device/:deviceType/:deviceId", {
        deviceType: device.type,
        deviceId: device.id,
      })}
      className="device-preview"
    >
      <div className="item icon">
        <BoosterIcon />
      </div>
      <div style={{ flex: 0.5 }} />
      <div className="device content">
        <div className="item description">
          {device.name ? <div className="title">{device.name}</div> : ""}
          <div className="serial">
            <div className="prefix">SN:</div>
            <div>{device.serialNumber}</div>
          </div>
        </div>
        <div className="item status">
          <DeviceStatus status={device.status} />
        </div>
        <div className="item electricity_used">
          <div className="electricity_value">
            <div>{formatElectricity(device.currentlyUsed)}</div>
            <div>/</div>
            <div>{formatElectricity(device.maxSetCurrent)}</div>
          </div>
          <DevicePhase phasesActiveStatus={device.phasesActiveStatus} />
        </div>
      </div>
      <div className="item settings">
        <DotsSVG />
      </div>
    </Link>
  );
}

export default DevicePreview;
